import React, {Component} from 'react';
import axios from 'axios';
import PageSection from '../components/PageSection/PageSection.js';
import PageLayout from '../components/PageLayout/PageLayout.js';
import PageContent from '../components/PageContent/PageContent.js';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {actionCreators as filterActions} from '../actions/searchBarActions';
import ReactGA from 'react-ga';
import APPCONST from '../constants/constants';
// import Survey from '../components/Survey/survey'

ReactGA.initialize(APPCONST.googleAnalyticsCode);

class HomePage extends Component{
	state={
    	content:[],
    	sections:[],
    	layout:'VERTICAL',
  	};

	componentDidMount=()=>{
    	this.getPageData();
		this.props.removeAllFilters();
		//Google analytics
		ReactGA.pageview(window.location.pathname + window.location.search);
	}

	componentDidUpdate=(prevProps)=>{
		if(prevProps.page!==this.props.page){
			this.getPageData();
    		this.props.removeAllFilters();
		}
	}
	
	getPageData(){
		axios.get(window.global.content_hub.API+'/api/page_content',{
				params:{
					region:window.global.content_hub.region,
					page:this.props.page,
				}
			})
			.then((res)=>{
				this.setState({
					content:res.data.content,
					sections:res.data.sections,
					layout:res.data.layout.Layout,
				});
			})
			.catch((err)=>{
				console.log(err);
			});
	}

	render(){
		let sections=[];

		this.state.sections.forEach((section)=>{
			let section_content=[];
			this.state.content.forEach((content)=>{
				if(content.Section_options)
					for(let i=0;i<content.Section_options.length;i++)
						if(content.Section_options[i].Section_ID===section.Section_ID)
							section_content.push(
								<PageContent
									key={content.ID}
									position={content.Section_options[i].Position}
									data={content}
									Title={section.Title}
								/>
							);		
			});
		
			sections.push(
				<PageSection
					key={section.Section_ID}
					layout={section.Layout}
					data={section}
					position={section.Position}
				>
					{section_content}
				</PageSection>
			);
		});



		return (
			<React.Fragment>
				{this.props.children}
				<div className="mainContent">
					<PageLayout layout={this.state.layout} sort={true} increment={0}>
						{sections}
					</PageLayout>
					{/* <Survey></Survey> */}
				</div>
			</React.Fragment>
		);
	}
}

export default connect(
	(state)=>{
    	const {filterData}=state;
    	return {filterData};
  	},
  	(dispatch)=>bindActionCreators({...filterActions},dispatch)
)(HomePage);